import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type ModalName = 'login';

interface ModalState {
  activeModal: ModalName | null;
  props: Record<string, unknown>;
}

const initialState: ModalState = {
  activeModal: null,
  props: {},
};

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openModal: (
      state,
      action: PayloadAction<{ name: ModalName; props?: Record<string, unknown> }>
    ) => {
      state.activeModal = action.payload.name;
      state.props = action.payload.props ?? {};
    },
    closeModal: (state) => {
      state.activeModal = null;
      state.props = {};
    },
  },
});

export const { openModal, closeModal } = modalSlice.actions;
export default modalSlice.reducer;
